import { Stack, Typography, Box } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import { ClientOptionButton } from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';

export default function IsSmoke({ userData, setUserData, onNext }) {
  const { theme } = useClient();

  const handleOptionSelect = (field, value) => {
    setUserData({ ...userData, [field]: value });
    // Call onNext directly after selection to move to the next step
    onNext();
  };

  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
    >

      <StepsHeading title={"Do you smoke?"} />
      {[
        { label: "Yes", value: true },
        { label: "No", value: false },
      ].map((option, index) => (
        // <Box
        //   key={ index }
        //   onClick={ () => handleOptionSelect( 'isSmoke', option.value ) }
        //   sx={ {
        //     width: {
        //       xs: '280px',
        //       sm: '300px',
        //       md: '400px',
        //       lg: '450px'
        //     },
        //     maxWidth: '100%',
        //     height: {
        //       xs: '44px',
        //       md: '54px'
        //     },
        //     backgroundColor: userData.gender === option.value ? theme.primaryColor : "rgba(26, 26, 26, 0.08)",
        //     marginBottom: "10px",
        //     borderRadius: '10px',
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     cursor: 'pointer',
        //     transition: 'all 0.2s ease-in-out',
        //     color: userData.gender === option.value ? "white" : '#000',
        //     '&:hover': {
        //       transform: 'scale(1.02)',
        //       color: 'white',
        //       backgroundColor: theme.primaryColor,
        //     }
        //   } }
        // >
        //   <Typography
        //     sx={ {
        //       fontSize: {
        //         xs: '14px',
        //         sm: '16px',
        //         md: '18px'
        //       },
        //       fontWeight: '400',
        //     } }
        //   >
        //     { option.label }
        //   </Typography>
        // </Box>
        <ClientOptionButton
          optionSelectSingleValue={userData.isSmoke}  // Pass the current selected value
          value={option.value}  // Pass value to compare with userData
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('isSmoke', option.value)}
        />
      ))}
    </Stack>
  );
}